var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-btn',{attrs:{"elevated":"","color":_vm.active ? 'white' : 'secondary',"text-color":_vm.active ? 'black' : 'white',"label":_vm.active ? _vm.cancelLabel : _vm.selectLabel},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }